import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { trendingComics } from '@/mocks/comics';

export default function TrendingSection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">读者们最喜爱的韩漫作品，热度爆表</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {trendingComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="compact" />
          ))}
        </div>
      </div>
    </section>
  );
}